import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import { fetchStatusCommentTypes, fetchActivitiesIssues } from '../../actions/project_actions';


class AddCommentForm extends React.Component {
  // static PropTypes = {
  //   comment: PropTypes.object.isRequired,
  //   onSubmit: PropTypes.func.isRequired,
  //   statusCommentTypes: PropTypes.array.isRequired,
  //   activitiesIssues: PropTypes.array.isRequired,
  //   fetchStatusCommentTypes: PropTypes.func.isRequired,
  //   fetchActivitiesIssues: PropTypes.func.isRequired,
  // }

  constructor (props) {
    super(props);

    this.statusComentFields = ['typeId', 'activityIssueId'];

    this.state = {
      ...this.getInitialState(props.comment), 
      ..._.pick(props.comment, this.statusComentFields),
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleActivityChange = this.handleActivityChange.bind(this);
  }

  getInitialState ({
    statusForProject='',
    comment='',
    type='',
    activityIssueId=''
  }) {
    return {
      statusForProject,
      comment,
      type,
      activityIssueId,
    }
  }

  UNSAFE_componentWillMount() {
    const { statusCommentTypes, activitiesIssues } = this.props;

    if (statusCommentTypes.length === 0) this.props.fetchStatusCommentTypes();
    if (activitiesIssues.length === 0) this.props.fetchActivitiesIssues();
  }

  getTypeOptions() {
    return this.props.statusCommentTypes.map(type => {
      return {
        label: type.type,
        value: type.id
      }
    });
  }

  getActivityOptions() {
    return this.props.activitiesIssues.map(activity => {
      return {
        label: activity.description,
        value: activity.id
      }
    });
  }

  handleDateChange (name) {
    return (date) => {
      this.setState({
        [name]: date,
      });
    }
  }

  handleChange (field) {
    return (e) => {
      this.setState({ [field]: e.target.value });
    }
  }

  handleTypeChange(option) {
    const typeId = option ? option.value : '';
    this.setState({ typeId });
  }

  handleActivityChange(option) {
    const activityIssueId = option ? option.value : '';
    this.setState({ activityIssueId });
  }

  handleSubmit (e) {
    e.preventDefault();
    const fields = 'typeId,statusForProject,comment'.split(',');
    const values = _.pick(this.state, fields)

    const fieldsActivity = 'typeId,activityIssueId,comment'.split(',');
    const valuesActivity = _.pick(this.state, fieldsActivity)

    if ( _.every(values) ) {
      this.props.onSubmit({
        ...this.props.comment,
        ...values
      });
    }
    else if ( _.every(valuesActivity) ) {
      this.props.onSubmit({
        ...this.props.comment,
        ...valuesActivity
      });
    }
  }

  render() {
    const { statusForProject, comment, typeId, activityIssueId } = this.state;

    let canSubmit = false; 
    if (typeId=== 1) 
     canSubmit = (comment!==undefined && comment!=='') && (statusForProject!==undefined && statusForProject!=='') 
   else if (typeId === 2)
     canSubmit = (comment!==undefined && comment!=='') && (activityIssueId!==undefined && activityIssueId!=='') 

    return (
      <form className="modal-form comments-form" onSubmit={this.handleSubmit}>
        <div className="control required">
          <label>Type</label>
          <Select name=""
            value={typeId}
            options={this.getTypeOptions()}
            onChange={this.handleTypeChange}
          />
        </div>

        {typeId === 1
          ? <div>
            <div className="control required">
              <label>Status For</label>
              <input type="text" name="statusForProject"
                value={statusForProject}
                onChange={this.handleChange('statusForProject')}
              />
            </div>

            <div className="control required">
              <label>Comments</label>
              <textarea name="comment" cols='3' rows='5'
                value={comment}
                onChange={this.handleChange('comment')}></textarea>
            </div>
          </div>
          : null}

        {typeId === 2
          ? <div>
            <div className="control">
              <label>Activities and Issues</label>
              <Select name=""
                value={activityIssueId}
                options={this.getActivityOptions()}
                onChange={this.handleActivityChange}
              />
            </div>

            <div className="control required">
              <label>Comments</label>
              <textarea name="comment" cols='3' rows='5'
                value={comment}
                onChange={this.handleChange('comment')}></textarea>
            </div>
          </div>
          : null}
      

        <button className="btn-update" disabled={!canSubmit}>Add</button>
      </form>
    )
  }
}

AddCommentForm.propTypes = {
  comment: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  statusCommentTypes: PropTypes.array.isRequired,
  activitiesIssues: PropTypes.array.isRequired,
  fetchStatusCommentTypes: PropTypes.func.isRequired,
  fetchActivitiesIssues: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    statusCommentTypes: state.projectsStore.statusCommentTypes,
    activitiesIssues: state.projectsStore.activitiesIssues,
  };
}


export default connect (mapStateToProps, {fetchStatusCommentTypes,fetchActivitiesIssues}) (AddCommentForm);